var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNistLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1188_6336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.29412 30C4.35294 30 2 32.3488 2 35.2848V49.9647H6.70588V35.2848C6.70588 34.815 7.29412 34.5801 7.70588 34.8737L20.0471 48.3911C23.4588 51.7968 29.1059 49.3306 29.1059 44.7504V29.953H24.4V44.7504C24.4 45.2202 23.8118 45.4551 23.4235 45.1615L11.1294 31.6559C9.95294 30.4815 9.01176 30.0117 7.30588 30.0117M31.4353 30V44.68C31.4353 46.0816 31.9931 47.4258 32.9859 48.4169C33.9787 49.408 35.3253 49.9647 36.7294 49.9647H56.4706C58.1087 49.9647 59.6797 49.3152 60.838 48.1589C61.9963 47.0026 62.6471 45.4344 62.6471 43.7992C62.6471 42.1639 61.9963 40.5957 60.838 39.4394C59.6797 38.2832 58.1087 37.6336 56.4706 37.6336H44.0941C43.7041 37.6336 43.33 37.4789 43.0542 37.2036C42.7785 36.9283 42.6235 36.5549 42.6235 36.1656C42.6235 35.7762 42.7785 35.4028 43.0542 35.1275C43.33 34.8522 43.7041 34.6976 44.0941 34.6976H64.9765V49.9647H69.6824V34.6976H77.9176V30H44.0941C42.456 30 40.885 30.6496 39.7267 31.8058C38.5684 32.9621 37.9176 34.5304 37.9176 36.1656C37.9176 37.8008 38.5684 39.369 39.7267 40.5253C40.885 41.6816 42.456 42.3312 44.0941 42.3312H56.4471C56.8371 42.3312 57.2111 42.4858 57.4869 42.7611C57.7627 43.0364 57.9176 43.4098 57.9176 43.7992C57.9176 44.1885 57.7627 44.5619 57.4869 44.8372C57.2111 45.1125 56.8371 45.2672 56.4471 45.2672H36.7412C36.5852 45.2672 36.4355 45.2053 36.3252 45.0952C36.2149 44.985 36.1529 44.8357 36.1529 44.68V30H31.4353Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1188_6336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 20,
    fill: "white",
    transform: "translate(2 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNistLogoDark);
export default __webpack_public_path__ + "static/media/nist-logo-dark.de3a4654e5fe9c7449c250c3fbfe5464.svg";
export { ForwardRef as ReactComponent };